import SlideshowContainer from './SlideshowContainer';

export default SlideshowContainer;
